import http from "./httpService";
import auth from "./authService";
import { RoyaltyReportPayload } from "../interface/api/RoyaltyReportPayload";

http.setJwt(auth.getJwt());

const BASE = "/api/royalty";

export const generateReport = (payload: RoyaltyReportPayload) => {
  return http.post(`${BASE}/report`, payload);
};

export const getConfig = () => {
  return http.get(`${BASE}/config`);
};

export default {
  generateReport,
  getConfig,
};
